import _Object$keys from 'babel-runtime/core-js/object/keys';
/* eslint-disable prefer-template */
export default function objectToGetParams(object) {
  return '?' + _Object$keys(object).filter(function (key) {
    return !!object[key];
  }).map(function (key) {
    return key + '=' + encodeURIComponent(object[key]);
  }).join('&');
}
/* eslint-enable prefer-template */


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-share/es/utils/objectToGetParams.js
// module id = 916
// module chunks = 0 1 2 3 4 5 6 7